export default __webpack_public_path__ + "static/media/mapGen.9dba556c.gif";